<template>
  <div class="user-button" @click="continueAs(userId)">
    <div v-if="!errorMessage" class="user-button-content">
      <user-information :first-name="firstName" :last-name="lastName" :email="email" :other="other" />
      <svgicon name="arrow-right" />
    </div>
    <div class="user-button-error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { getAndRemoveItem } from '@/lib/utils/storage';
import userInformation from './user_information';
import loginAs from '@/lib/api/account/loginAs';

const _ = {
  getAndRemoveItem,
  window,
};

export default {
  components: {
    userInformation,
  },
  props: {
    other: {
      type: Boolean,
      default: false,
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    userId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      errorMessage: null,
    };
  },

  methods: {
    async continueAs(userId) {
      try {
        if (userId) { await loginAs.execute(userId); }

        _.window.localStorage.setItem('hasWorksForAccess', true);
        const returnPath = _.getAndRemoveItem('returnPath');
        _.window.location.assign(returnPath || '/app/clients');
      } catch (exception) {
        this.errorMessage = this.$t('Sorry, we could not log you in. Please contact your administrator.');
        console.error('Login as another advisor (works for) failed');
        console.error(exception);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.user-button {
  cursor: pointer;
  border: 1px solid $neutral-300;
  padding: 1.5rem;
  width: 400px;
  height: 93px;

  .user-button-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &:hover {
    background-color: $neutral-50;
  }

  &:first-of-type {
    border-top: 1px solid $neutral-300;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  &:only-of-type {
    border-radius: 6px;
  }

  & ~ .user-button {
    border-top: 0;
    border-radius: 0;

    &:nth-last-of-type(1) {
      border-top: 0;
      border-radius: 0 0 6px 6px;
    }
  }
}

svg {
  width: 20px;
  min-width: 20px;
  max-width: 20px;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  margin-right: 0.75rem;
  transition: all 0.3s ease-in-out;
  position: relative;
  left: 0;
}

.user-button:hover svg {
  left: 5px;
}

.user-button-error {
  width: 100%;
  color: $neg-500;
}

@media screen and (max-width: 400px) {
  .user-button {
    width: calc(100vw - 1.5rem);
    padding: 0.75rem;
    height: auto;
  }

  svg {
    right: 0;
  }
}

</style>
